var niceScrollConfig = {
	cursorwidth: 10,
	cursorborder: "none",
	cursorborderradius: 0,
	horizrailenabled: false,
	autohidemode: false
};
